import { useLenis } from "@/hooks/useLenis";
import { useSEO } from "@/components/site/SEO";
import { SITE } from "@/config/site";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { FloatingCTA } from "@/components/site/FloatingCTA";
import { Contact } from "@/sections/Contact";
import { QuoteForm } from "@/sections/QuoteForm";
import { Reveal } from "@/components/site/Reveal";

export default function ContactPage() {
  useLenis();
  useSEO({
    title: "Contact Us | GoCleaning Dublin",
    description: "Contact GoCleaning Dublin for end of tenancy, move-out and commercial cleaning quotes. Call, WhatsApp or email us, or request a quote online.",
    canonical: `${SITE.url}/contact`,
  });

  return (
    <div className="App bg-white">
      <Header />
      <main className="pt-16">
        <div className="mx-auto max-w-7xl px-4 pt-12 sm:px-6 lg:px-8">
          <Reveal>
            <h1 className="font-display text-5xl font-black tracking-tighter text-slate-900 sm:text-6xl">Contact Us</h1>
            <p className="mt-4 max-w-2xl text-lg text-slate-600">Get in touch for a fast, clear quote across {SITE.serviceArea}.</p>
          </Reveal>
        </div>
        <Contact />
        <QuoteForm sourcePage="/contact" />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}
